import { render } from "./SuccessTicketComponent.vue?vue&type=template&id=5335434f"
import script from "./SuccessTicketComponent.vue?vue&type=script&lang=js"
export * from "./SuccessTicketComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__